module.exports = __webpack_public_path__ + "img/g3.5df1dfa2.jpg";